export default "__VITE_ASSET__0b10f6c7__"